import { render } from "./hospitalInfo.vue?vue&type=template&id=4c64840c"
import script from "./hospitalInfo.vue?vue&type=script&lang=js"
export * from "./hospitalInfo.vue?vue&type=script&lang=js"

import "./hospitalInfo.vue?vue&type=style&index=0&id=4c64840c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__